import { ChangeDetectorRef } from "@angular/core";

/**
 * unless an OperatorFunction or otherwise deferred see detachedFn
 */
export function detached<T>(
  ref: { cd: ChangeDetectorRef },
  callback: (...args: any[]) => T,
  applyThis?: any,
  applyArgs?: any[],
): T {
  let value: T;
  ref.cd.detach();
  value = callback.apply(applyThis, applyArgs);
  ref.cd.detectChanges();
  ref.cd.reattach();
  return value;
}

export function detachedFn<T>(
  ref: { cd: ChangeDetectorRef },
  callback: (...args: any[]) => T,
  applyThis?: any,
  applyArgs?: any[],
): () => T {
  return () => {
    return detached(ref, callback, applyThis, applyArgs);
  };
}
